import React from 'react';
import { List } from 'antd';
import wandu from '../../service/wandu';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';
import styles from './index.css';

const section = [
{
    title: '万读畅销榜',
    key: 'sale',
},
{
    title: '男生点击榜',
    key: 'man',
},
{
    title: '女生点击榜',
    key: 'woman',
},
{
    title: '万读更新榜',
    key: 'update',
},
];

class WeelList extends React.Component {

    render(){
        const {datas, sort_num} = this.props
        return (
            <div className={sort_num===0?styles.week_list_0:(sort_num===0?styles.week_list_1:styles.week_list_2)}>
                {datas.map((val,idx)=>(
                    <div key={val.id} className={sort_num%2===0?styles.rank_bg_1:styles.rank_bg_2}>
                        <Link to={`/book/detail/${val.novel_id}`}>
                        <p className={styles.rank_num}>NO.{val.index}</p>
                        {sort_num===0 && <img src={val.pic} alt=''/>}
                        <div className={styles.rank_novel_name}><LinesEllipsis maxLine={1} text={val.novel_name}/></div>
                        </Link>
                        <div className={styles.rank_author_info}>{val.tag_name}<span>|</span>{val.author_name}</div>
                    </div>
                ))}
            </div>
        )
    }
}


export default class NewRank extends React.Component {

    state = {
        week: {}, 
        month: {}, 
        week_arr:[],
        cur_key:'sale'
    }

    componentDidMount() {
        var that = this;
        wandu.top_list({type: 'week', num: 9}).then(res => {
            const datas = section.map(item =>{
                var lsArr = res[item.key].list.slice(0);
                // 调到数组前两位位置，
                lsArr[0] = lsArr.splice(1,1,lsArr[0])[0];
                var newArr = new Array(3);
                lsArr.forEach((item, index) => {
                    const num = Math.floor(index / 3); // 计算该元素为第几个素组内
                    if (!newArr[num]) { // 判断是否存在
                        newArr[num] = [];
                    }
                    // 自定义索引，便于处理排名
                    if(index===0){
                        item.index = 2;
                    }else if(index===1){
                        item.index = 1;
                    }else{
                        item.index = index+1;
                    }
                    newArr[num].push(item);
                });
                
                return {
                    title: item.title,
                    key:item.key,
                    week: newArr
                }
            });
            that.setState({
                week_arr:datas
            })
        }).catch(e => {
            console.log(e); 
        });
    }

    changeRankFn = (e) => {
        console.log(e.target.getAttribute('cur_tab'));
        this.setState({
            cur_key:e.target.getAttribute('cur_tab')
        })
    }

    render() {
        const data = section.map(item => ({
            title: item.title,
            key:item.key,
            week: this.state.week[item.key]
        }));
        return (
        <div style={{background:'#f9f9f9'}}>
            <div style={{width:'1000px',margin:'0 auto'}}>
                <List
                    grid={{column: 4, gutter: 20}}
                    dataSource={data}
                    renderItem={item => (
                        <List.Item>
                            <div cur_tab={item.key} className={this.state.cur_key===item.key?styles.cur_tab_style:styles.tab_style} onClick={this.changeRankFn} >{item.title}</div>
                        </List.Item>
                    )}/>
                {(this.state.week_arr).length!==0 &&<ul>
                    {this.state.week_arr.filter(item=>item.key===this.state.cur_key)[0].week.map((val,idx)=>(
                        <li key={idx}>
                            <WeelList datas={val} sort_num={idx}/>
                        </li>
                    ))}
                </ul>}
                <div className={styles.see_more} style={{background:'#f9f9f9'}}>
                    <Link to={'/rank'}>
                        <span>查看更多</span>
                    </Link>
                </div>
            </div>
        </div>
        ); 
    }

}



// WEBPACK FOOTER //
// ./src/layout/home/newrank.js